export default "__VITE_ASSET__CXlB4l2K__"